import React from "react";
import Certificate from "./Certificate";
import { useGlobalContext } from "../context";
import Loading from "./Loading";
import { Link } from "react-router-dom";

const CertificatesPage = () => {
  const { apiClient } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [certificates, setCertificates] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      try {
        const res = await apiClient.get("/certificates/my");
        if (res.status >= 200 && res.status < 300) {
          setCertificates(res.data);
        }
      } catch (error) {
        alert(error);
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return (
    <div>
      <h1 className="display-6 text-muted mb-4 d-print-none">
        Print My Certificates
      </h1>
      {loading ? (
        <Loading />
      ) : certificates.length === 0 ? (
        <>
          <h5 className="mb-0 d-print-none">
            You don't have any certificates yet.
          </h5>
          <p className="d-print-none">
            Please contact the school to give a test.
          </p>
        </>
      ) : (
        certificates.map((c, i) => <Certificate key={i} certificate={c} />)
      )}
      <br />
      <Link className="btn btn-outline-secondary px-5 mt-5 d-print-none" to="/">
        Go Back
      </Link>
    </div>
  );
};

export default CertificatesPage;
